import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlHelper'
})
export class HtmlHelperPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return value.replace(/\n/g,'<br/>');
  }

}
